import React from "react";
import { Route, Switch, useParams } from "react-router-dom";
import LegacyFrame from "../Components/LegacyFrame";
import { LoginInfo } from "../Utils/Login";

interface WikiProps {
  loginInfo: LoginInfo;
}

export default function Wiki(props: WikiProps) {
  return (
    <Switch>
      <Route path={`/wiki/:pageId`}>
        <WikiWithID loginInfo={props.loginInfo} />
      </Route>
      <Route path={`/wiki`}>
        <LegacyFrame route="/wiki.php" loginInfo={props.loginInfo} />
      </Route>
    </Switch>
  );
}

interface WikiWithIDParamTypes {
  pageId: string;
}
function WikiWithID(props: WikiProps) {
  let { pageId } = useParams<WikiWithIDParamTypes>();
  return (
    <LegacyFrame
      route={"/wiki.php?page=" + pageId}
      loginInfo={props.loginInfo}
    />
  );
}
